import CONFIG from 'app.config';

import Logger from './Logger';

// Note - these are the only sizes used in the app at the moment, not necessarily all sizes available
enum S3ImageSize {
  SMALL = '200x200',
  LARGE = '700x700',
}

interface S3ImageParams {
  name?: string;
  extension?: string;
  size?: S3ImageSize;
}

export const getS3ImageUrl = (params: S3ImageParams) => {
  const { name, extension, size = S3ImageSize.SMALL } = params || {};
  if (!name || !extension) {
    Logger.error('Name and extension are required', { params });
    return null;
  }

  return `${CONFIG.S3_BUCKET_URL}${name}-${size}.${extension}`;
};

// Not used right now, but could be useful
export const validateS3Image = async ({ name, extension, size }: S3ImageParams) => {
  const s3Url = getS3ImageUrl({ name, extension, size });
  if (!s3Url) {
    Logger.error('Invalid S3 image');
    return null;
  }

  const response = await fetch(s3Url);
  if (!response.ok) {
    Logger.error('Invalid S3 image');
    return null;
  }
  return s3Url;
};
